import { Grid, Stack, Text } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { useTranslation } from "react-i18next";
import { getDisplayedFovealThreshold } from "@utils";

const useStyles = createStyles((_theme) => ({
  gridColCenter: {
    textAlign: "center",
    fontWeight: 500,
  },

  gridCol: {
    fontWeight: 500,
  },
}));

export default function InfoWrappedMaps(props) {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Stack gap={0} {...props}>
      <Grid columns={10}>
        <Grid.Col className={classes.gridCol} span={props.half ? 5 : 2}>
          {props.date}
        </Grid.Col>
        <Grid.Col
          className={props.half ? classes.gridColCenter : classes.gridCol}
          span={props.half ? 5 : 2}
        >
          {props.behaviour}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={props.half ? 5 : 2}>
          {"GHT: " + (props.ght ?? "")}
        </Grid.Col>
        <Grid.Col className={classes.gridColCenter} span={props.half ? 5 : 4}>
          {props.lowReliability && <Text color="red.7">{t("LowReliability")}</Text>}
        </Grid.Col>
      </Grid>
      {props.children}
      <Grid gutter="xs" columns={30}>
        <Grid.Col className={classes.gridCol} span={props.half ? 15 : 6} order={props.half ? 4 : 1}>
          {"VFI: " + (props.vfi ?? "") + " %"}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={props.half ? 15 : 6} order={props.half ? 5 : 2}>
          {"MD: " + (props.md ? props.md.toFixed(2) : "") + " dB"}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={props.half ? 10 : 6} order={props.half ? 1 : 3}>
          {props.fl && "FL: " + (props.fl ?? "")}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={props.half ? 10 : 6} order={props.half ? 2 : 4}>
          {"FN: " + (props.fn ?? "") + " %"}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={props.half ? 10 : 6} order={props.half ? 3 : 5}>
          {"FP: " + (props.fp ?? "") + " %"}
        </Grid.Col>
      </Grid>
      <Grid gutter="xs" columns={10}>
        <Grid.Col className={classes.gridCol} span={2}>
          {getDisplayedFovealThreshold(props.fovea) != null &&
            "Fovea: " + getDisplayedFovealThreshold(props.fovea) + " dB"}
        </Grid.Col>
        <Grid.Col className={classes.gridCol} span={2}>
          {"PSD: " + (props.psd ? props.psd.toFixed(2) : "") + " %"}
        </Grid.Col>
        <Grid.Col className={classes.gridColCenter} span={6}>
          {props.progressionStatusText}
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
